import _ from 'lodash'
import axios from 'axios'
import ModaleGauche from '../../modals/modale_gauche.vue'
import LoadingBtn from '../../../common/ui/loading_btn.vue'
import FieldAdresse from '../../maps/field_adresse.vue'
import DrawingModes from './drawing_modes.vue'


export default {
	data() {
		return {
			
		}
	},
	props: [],
	watch: {
		
	},
	created(){
		
	},
	mounted(){
	},
	methods: {},
	computed:{
		
	},
	components:{
		ModaleGauche,
		LoadingBtn,
		FieldAdresse,
		DrawingModes
	}
}